import { useIntl } from "react-intl";

import { EnterpriseHero } from "@/components/enterprise/enterprise-hero-v2/src/enterprise-hero";
import { useLocalizedHref } from "@/libraries/web-framework";

export const AnalystsTabContent = () => {
    const intl = useIntl();

    return (
        <EnterpriseHero
            headerText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.analysts.header",
                defaultMessage:
                    "Atlassian named a Leader in DevOps Platforms by Gartner"
            })}
            bodyText={intl.formatMessage({
                id: "EnterpriseLandingPage.hero.analysts.body",
                defaultMessage:
                    "Learn about our unified DevOps platform that connects engineering, IT Ops, and business teams"
            })}
            textAlign="right"
            cta={{
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.hero.analysts.cta",
                    defaultMessage: "Read the report"
                }),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "heroSection",
                    "data-event": "clicked",
                    "data-label": "enterprise-hero-analysts-cta",
                    "data-label-english": "Read the report"
                },
                href: useLocalizedHref("/gartner/magic-quadrant-devops")
            }}
            ctaType="button"
            color="light"
            backgroundImgSrc={{
                xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-xs.webp",
                sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-sm.webp",
                md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-md.webp",
                lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-lg.webp"
            }}
        />
    );
};
